import { render, staticRenderFns } from "./ToccaVinoHome.vue?vue&type=template&id=470b3051&scoped=true&"
import script from "./ToccaVinoHome.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoHome.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoHome.vue?vue&type=style&index=0&id=470b3051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b3051",
  null
  
)

export default component.exports